<ng-container *transloco="let t">
    <div *ngIf="type === FilterGroupType.SINGLE_SELECT_BUTTONS">
        <div class="d-flex align-items-center gap-2">
            @for (item of filteredItems; track item.id) {
            <div class="dropdown-small chevron-none show-hover min-width-59"
                [class.selected]="item.selected" (click)="toggleItem($event, item)">
                <div class="dropdown-toggle justify-content-center">
            {{ item.labelKey ? t(item.labelKey) : (item.label ?? "-" ) }}
            </div>
        </div>
            }
        </div>
    </div>

    <div *ngIf="type === FilterGroupType.MULTI_SELECT || type === FilterGroupType.SINGLE_SELECT">
        <div *ngIf="isDesktop">
            <div ngbDropdown #desktopDropdown="ngbDropdown" container="body"
                 class="dropdown-small me-2"
                 (openChange)="onDesktopDropdownOpen($event)">
                <div [id]="id" ngbDropdownToggle>
                    <ng-container *ngTemplateOutlet="itemTitle"></ng-container>
                </div>
                <div ngbDropdownMenu class="px-3 pb-3 mt-1">
                    <div *ngIf="allowSearchItems" class="mb-2">
                        <app-search [minWidth]="'300px'" [placeholder]="''" (searchQuery)="handleInput($event)" [inputValue]="searchText" [id]="id + '-search'"/>
                    </div>
                    <div class="scrollable">
                        <ng-container *ngTemplateOutlet="itemList"></ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!isDesktop">
            <div class="dropdown-small" (click)="onOpenMobileFilter()">
                <div class="dropdown-toggle">
                    <ng-container *ngTemplateOutlet="itemTitle"></ng-container>
                </div>
            </div>
        </div>

        <ng-template #offcanvasContent let-offcanvas>
            <div class="sheet-header">
                <div class="d-flex justify-content-between align-items-center ">
                    <span class="fs-18 fw-500">{{ title }}</span>
                    <button type="button" class="btn-unstyled" aria-label="Close"
                            (click)="onClose()">
                        <img src="assets/img/svg/close-modal.svg" alt="Close modal" style="height: 37px; width: 37px;">
                    </button>
                </div>
                <div *ngIf="allowSearchItems">
                    <app-search [isFullScreen]='true' [placeholder]="''" (searchQuery)="handleInput($event)" [inputValue]="searchText" [id]="id + '-search'"/>
                </div>
            </div>
            <div class="sheet-body p-10">
               <ng-container *ngTemplateOutlet="itemList"></ng-container>
            </div>
            <div class="sheet-footer">
                <div class="row">
                    @if (!requiredAny) {
                    <div class="col">
                        <app-button-alt [buttonColor]="'white'" [textColor]="'var(--teal-500)'"
                                        [text]="t('app.common.filters.clearAll')" [borderColor]="'var(--teal-500)'"
                                        (onClickCallback)="onClear()" [isFullWidth]="true"
                                        [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
                    </div>
                    }
                    <div class="col">
                        <app-button-alt [text]="t('app.register.to.race.apply')"
                                        (onClickCallback)="onApply()" [isFullWidth]="true"
                                        [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #itemTitle>
            @if (showSelectionAsLabel) {
            {{(items | selectedFilterLabel:t) || title}}
            }
            @else {
            {{
            title
            }}
            }
        </ng-template>

        <ng-template #itemList>
            <div class="filter-checkbox-list pt-8">
                <label class="item" *ngFor="let item of filteredItems">
                    <input type="checkbox"
                           [checked]="item.selected"
                           (click)="toggleItem($event, item)">
                    <span class="label"> {{ item.labelKey ? t(item.labelKey) : (item.label ?? "-" ) }} </span>
                </label>
            </div>
        </ng-template>
    </div>

</ng-container>